import React from 'react';

import TableHeaderWrapper from '../../../modules/table-header-wrapper/table-header-wrapper';

import './ucp-header.scss';

const UCP_HEADER_TITLE = 'Решение о выпуске гибридного токена';
const UCP_SALE_HEADER_TITLE = 'Продажа цифровых финансовых активов';
const UCP_PURCHASE_HEADER_TITLE = 'Покупка цифровых финансовых активов';
const UCP_EXCHANGE_HEADER_TITLE = 'Обмен цифровых финансовых активов';
interface UcpHeaderProps {
  onClose: () => void;
  isSelling?: boolean;
  isUcpIssuing?: boolean;
  isExchange?: boolean;
  title?: React.ReactNode;
}

const UcpHeader: React.FC<UcpHeaderProps> = ({
  onClose,
  isSelling,
  isUcpIssuing,
  isExchange,
  title,
}) => (
  <div className="ucp__header">
    <TableHeaderWrapper
      isHint={isUcpIssuing}
      hintPage="ISSUE_HYBRID"
      onCloseClick={onClose}
      leftContent={
        title
          ? title
          : isUcpIssuing
          ? UCP_HEADER_TITLE
          : isSelling
          ? UCP_SALE_HEADER_TITLE
          : isExchange
          ? UCP_EXCHANGE_HEADER_TITLE
          : UCP_PURCHASE_HEADER_TITLE
      }
    />
  </div>
);

export default UcpHeader;
